// extracted by mini-css-extract-plugin
module.exports = {"modal":"m9","container":"na","actions":"nb","button":"nc","text":"nd"};